var generateStyle = function generateStyle(componentTheme) {
  return {
    sidebarItem: {
      borderBottom: "".concat(componentTheme.sidebarItemBorderWidth, " solid ").concat(componentTheme.sidebarItemBorderColor)
    },
    sidebarItemClosedButton: {
      borderRight: "".concat(componentTheme.hoverBorderWidth, " solid ").concat(componentTheme.borderColor),
      padding: componentTheme.sidebarClosedButtonPadding,
      textAlign: 'center',
      '&:hover': {
        borderRight: "".concat(componentTheme.hoverBorderWidth, " solid ").concat(componentTheme.hoverBorderColor)
      }
    },
    stimulusHeader: {
      padding: "".concat(componentTheme.sidebarHeaderPadding, " 0"),
      borderRight: "".concat(componentTheme.hoverBorderWidth, " solid ").concat(componentTheme.borderColor),
      '&:hover:': {
        borderRight: "".concat(componentTheme.hoverBorderWidth, " solid ").concat(componentTheme.hoverBorderColor)
      }
    },
    stimulusBody: {
      marginLeft: '5%'
    },
    infoHeader: {
      fontSize: componentTheme.sidebarIsOpenInfoHeaderFontSize,
      color: componentTheme.sidebarIsOpenInfoHeaderColor,
      marginBottom: componentTheme.sidebarIsOpenInfoHeaderMargin,
      paddingLeft: componentTheme.sidebarIsOpenInfoHeaderPadding
    }
  };
};
export default generateStyle;